import React from "react";
import KC_Heading2 from "../../../../../../designsystem/typography/KC-Heading/KC_Heading2";
import KC_Text from "../../../../../../designsystem/typography/KC_Text/KC_Text";
import {
  KC_Text_Sizes,
  KC_Weights
} from "../../../../../../designsystem/ds_commons";
import Separator from "../../../../../../components/Separator";
import POSAItem from "../POSAItem";
import { POSAOptionType } from "@tootsweet/model/entities/UploadedPOSA";
import { POSA_FORMAT } from "@tootsweet/model/lottery/POSAType";

interface Props {
  items: POSAOptionType[];
  title: string;
  description?: string;
  hidePlaceholderTitle?: boolean;
}

export default function SupportSection(props: Props) {
  const hasItems =
    props.items.length > 0 &&
    !props.items.some((item) => item.format === "none");

  if (!hasItems) return null;

  return (
    <div className="mt-3 mb-3">
      <KC_Heading2 text={props.title} className="mb-2" />

      {props.description && (
        <KC_Text
          text={props.description}
          size={KC_Text_Sizes.md}
          weight={KC_Weights.reg}
        />
      )}

      {props.items.map((item, idx) => (
        <React.Fragment key={item.format + idx}>
          <POSAItem
            hideDescription
            format={item.format as POSA_FORMAT}
            hidePlaceholderTitle={props.hidePlaceholderTitle}
          />
          <Separator />
        </React.Fragment>
      ))}
    </div>
  );
}
